import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-risklevel',
  templateUrl: './risklevel.component.html',
  styleUrls: ['./risklevel.component.scss']
})
export class RisklevelComponent {
  @Input() risklevelvalue?: number;

  constructor() { }

}
